import React, { useEffect, useState } from 'react';
import { collection, query, where, getDocs, addDoc, updateDoc, doc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../lib/firebase';
import { useStore } from '../store';
import type { CoachProfile } from '../types';
import { MapPin, Globe, Mail, Instagram, Facebook, Twitter, Linkedin, Save, X, Plus, Trash2, CheckCircle2 } from 'lucide-react';
import ImageUpload from '../components/ImageUpload';
import Select from 'react-select';
import { useTranslation } from '../i18n/useTranslation';

// List of all countries
const countries = [
  { value: 'Afghanistan', label: 'Afghanistan' },
  { value: 'Albania', label: 'Albania' },
  { value: 'Algeria', label: 'Algeria' },
  { value: 'Andorra', label: 'Andorra' },
  { value: 'Angola', label: 'Angola' },
  { value: 'Antigua and Barbuda', label: 'Antigua and Barbuda' },
  { value: 'Argentina', label: 'Argentina' },
  { value: 'Armenia', label: 'Armenia' },
  { value: 'Australia', label: 'Australia' },
  { value: 'Austria', label: 'Austria' },
  { value: 'Azerbaijan', label: 'Azerbaijan' },
  { value: 'Bahamas', label: 'Bahamas' },
  { value: 'Bahrain', label: 'Bahrain' },
  { value: 'Bangladesh', label: 'Bangladesh' },
  { value: 'Barbados', label: 'Barbados' },
  { value: 'Belarus', label: 'Belarus' },
  { value: 'Belgium', label: 'Belgium' },
  { value: 'Belize', label: 'Belize' },
  { value: 'Benin', label: 'Benin' },
  { value: 'Bhutan', label: 'Bhutan' },
  { value: 'Bolivia', label: 'Bolivia' },
  { value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina' },
  { value: 'Botswana', label: 'Botswana' },
  { value: 'Brazil', label: 'Brazil' },
  { value: 'Brunei', label: 'Brunei' },
  { value: 'Bulgaria', label: 'Bulgaria' },
  { value: 'Burkina Faso', label: 'Burkina Faso' },
  { value: 'Burundi', label: 'Burundi' },
  { value: 'Cabo Verde', label: 'Cabo Verde' },
  { value: 'Cambodia', label: 'Cambodia' },
  { value: 'Cameroon', label: 'Cameroon' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Central African Republic', label: 'Central African Republic' },
  { value: 'Chad', label: 'Chad' },
  { value: 'Chile', label: 'Chile' },
  { value: 'China', label: 'China' },
  { value: 'Colombia', label: 'Colombia' },
  { value: 'Comoros', label: 'Comoros' },
  { value: 'Congo', label: 'Congo' },
  { value: 'Costa Rica', label: 'Costa Rica' },
  { value: 'Croatia', label: 'Croatia' },
  { value: 'Cuba', label: 'Cuba' },
  { value: 'Cyprus', label: 'Cyprus' },
  { value: 'Czech Republic', label: 'Czech Republic' },
  { value: 'Denmark', label: 'Denmark' },
  { value: 'Djibouti', label: 'Djibouti' },
  { value: 'Dominica', label: 'Dominica' },
  { value: 'Dominican Republic', label: 'Dominican Republic' },
  { value: 'Ecuador', label: 'Ecuador' },
  { value: 'Egypt', label: 'Egypt' },
  { value: 'El Salvador', label: 'El Salvador' },
  { value: 'Equatorial Guinea', label: 'Equatorial Guinea' },
  { value: 'Eritrea', label: 'Eritrea' },
  { value: 'Estonia', label: 'Estonia' },
  { value: 'Eswatini', label: 'Eswatini' },
  { value: 'Ethiopia', label: 'Ethiopia' },
  { value: 'Fiji', label: 'Fiji' },
  { value: 'Finland', label: 'Finland' },
  { value: 'France', label: 'France' },
  { value: 'Gabon', label: 'Gabon' },
  { value: 'Gambia', label: 'Gambia' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Germany', label: 'Germany' },
  { value: 'Ghana', label: 'Ghana' },
  { value: 'Greece', label: 'Greece' },
  { value: 'Grenada', label: 'Grenada' },
  { value: 'Guatemala', label: 'Guatemala' },
  { value: 'Guinea', label: 'Guinea' },
  { value: 'Guinea-Bissau', label: 'Guinea-Bissau' },
  { value: 'Guyana', label: 'Guyana' },
  { value: 'Haiti', label: 'Haiti' },
  { value: 'Honduras', label: 'Honduras' },
  { value: 'Hungary', label: 'Hungary' },
  { value: 'Iceland', label: 'Iceland' },
  { value: 'India', label: 'India' },
  { value: 'Indonesia', label: 'Indonesia' },
  { value: 'Iran', label: 'Iran' },
  { value: 'Iraq', label: 'Iraq' },
  { value: 'Ireland', label: 'Ireland' },
  { value: 'Israel', label: 'Israel' },
  { value: 'Italy', label: 'Italy' },
  { value: 'Jamaica', label: 'Jamaica' },
  { value: 'Japan', label: 'Japan' },
  { value: 'Jordan', label: 'Jordan' },
  { value: 'Kazakhstan', label: 'Kazakhstan' },
  { value: 'Kenya', label: 'Kenya' },
  { value: 'Kiribati', label: 'Kiribati' },
  { value: 'Korea, North', label: 'Korea, North' },
  { value: 'Korea, South', label: 'Korea, South' },
  { value: 'Kosovo', label: 'Kosovo' },
  { value: 'Kuwait', label: 'Kuwait' },
  { value: 'Kyrgyzstan', label: 'Kyrgyzstan' },
  { value: 'Laos', label: 'Laos' },
  { value: 'Latvia', label: 'Latvia' },
  { value: 'Lebanon', label: 'Lebanon' },
  { value: 'Lesotho', label: 'Lesotho' },
  { value: 'Liberia', label: 'Liberia' },
  { value: 'Libya', label: 'Libya' },
  { value: 'Liechtenstein', label: 'Liechtenstein' },
  { value: 'Lithuania', label: 'Lithuania' },
  { value: 'Luxembourg', label: 'Luxembourg' },
  { value: 'Madagascar', label: 'Madagascar' },
  { value: 'Malawi', label: 'Malawi' },
  { value: 'Malaysia', label: 'Malaysia' },
  { value: 'Maldives', label: 'Maldives' },
  { value: 'Mali', label: 'Mali' },
  { value: 'Malta', label: 'Malta' },
  { value: 'Marshall Islands', label: 'Marshall Islands' },
  { value: 'Mauritania', label: 'Mauritania' },
  { value: 'Mauritius', label: 'Mauritius' },
  { value: 'Mexico', label: 'Mexico' },
  { value: 'Micronesia', label: 'Micronesia' },
  { value: 'Moldova', label: 'Moldova' },
  { value: 'Monaco', label: 'Monaco' },
  { value: 'Mongolia', label: 'Mongolia' },
  { value: 'Montenegro', label: 'Montenegro' },
  { value: 'Morocco', label: 'Morocco' },
  { value: 'Mozambique', label: 'Mozambique' },
  { value: 'Myanmar', label: 'Myanmar' },
  { value: 'Namibia', label: 'Namibia' },
  { value: 'Nauru', label: 'Nauru' },
  { value: 'Nepal', label: 'Nepal' },
  { value: 'Netherlands', label: 'Netherlands' },
  { value: 'New Zealand', label: 'New Zealand' },
  { value: 'Nicaragua', label: 'Nicaragua' },
  { value: 'Niger', label: 'Niger' },
  { value: 'Nigeria', label: 'Nigeria' },
  { value: 'North Macedonia', label: 'North Macedonia' },
  { value: 'Norway', label: 'Norway' },
  { value: 'Oman', label: 'Oman' },
  { value: 'Pakistan', label: 'Pakistan' },
  { value: 'Palau', label: 'Palau' },
  { value: 'Palestine', label: 'Palestine' },
  { value: 'Panama', label: 'Panama' },
  { value: 'Papua New Guinea', label: 'Papua New Guinea' },
  { value: 'Paraguay', label: 'Paraguay' },
  { value: 'Peru', label: 'Peru' },
  { value: 'Philippines', label: 'Philippines' },
  { value: 'Poland', label: 'Poland' },
  { value: 'Portugal', label: 'Portugal' },
  { value: 'Qatar', label: 'Qatar' },
  { value: 'Romania', label: 'Romania' },
  { value: 'Russia', label: 'Russia' },
  { value: 'Rwanda', label: 'Rwanda' },
  { value: 'Saint Kitts and Nevis', label: 'Saint Kitts and Nevis' },
  { value: 'Saint Lucia', label: 'Saint Lucia' },
  { value: 'Saint Vincent and the Grenadines', label: 'Saint Vincent and the Grenadines' },
  { value: 'Samoa', label: 'Samoa' },
  { value: 'San Marino', label: 'San Marino' },
  { value: 'Sao Tome and Principe', label: 'Sao Tome and Principe' },
  { value: 'Saudi Arabia', label: 'Saudi Arabia' },
  { value: 'Senegal', label: 'Senegal' },
  { value: 'Serbia', label: 'Serbia' },
  { value: 'Seychelles', label: 'Seychelles' },
  { value: 'Sierra Leone', label: 'Sierra Leone' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'Slovakia', label: 'Slovakia' },
  { value: 'Slovenia', label: 'Slovenia' },
  { value: 'Solomon Islands', label: 'Solomon Islands' },
  { value: 'Somalia', label: 'Somalia' },
  { value: 'South Africa', label: 'South Africa' },
  { value: 'South Sudan', label: 'South Sudan' },
  { value: 'Spain', label: 'Spain' },
  { value: 'Sri Lanka', label: 'Sri Lanka' },
  { value: 'Sudan', label: 'Sudan' },
  { value: 'Suriname', label: 'Suriname' },
  { value: 'Sweden', label: 'Sweden' },
  { value: 'Switzerland', label: 'Switzerland' },
  { value: 'Syria', label: 'Syria' },
  { value: 'Taiwan', label: 'Taiwan' },
  { value: 'Tajikistan', label: 'Tajikistan' },
  { value: 'Tanzania', label: 'Tanzania' },
  { value: 'Thailand', label: 'Thailand' },
  { value: 'Timor-Leste', label: 'Timor-Leste' },
  { value: 'Togo', label: 'Togo' },
  { value: 'Tonga', label: 'Tonga' },
  { value: 'Trinidad and Tobago', label: 'Trinidad and Tobago' },
  { value: 'Tunisia', label: 'Tunisia' },
  { value: 'Turkey', label: 'Turkey' },
  { value: 'Turkmenistan', label: 'Turkmenistan' },
  { value: 'Tuvalu', label: 'Tuvalu' },
  { value: 'Uganda', label: 'Uganda' },
  { value: 'Ukraine', label: 'Ukraine' },
  { value: 'United Arab Emirates', label: 'United Arab Emirates' },
  { value: 'United Kingdom', label: 'United Kingdom' },
  { value: 'United States', label: 'United States' },
  { value: 'Uruguay', label: 'Uruguay' },
  { value: 'Uzbekistan', label: 'Uzbekistan' },
  { value: 'Vanuatu', label: 'Vanuatu' },
  { value: 'Vatican City', label: 'Vatican City' },
  { value: 'Venezuela', label: 'Venezuela' },
  { value: 'Vietnam', label: 'Vietnam' },
  { value: 'Yemen', label: 'Yemen' },
  { value: 'Zambia', label: 'Zambia' },
  { value: 'Zimbabwe', label: 'Zimbabwe' }
];

export default function CoachProfile() {
  const { t } = useTranslation();
  const user = useStore((state) => state.user);
  const [profile, setProfile] = useState<CoachProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [formData, setFormData] = useState({
    schoolName: '',
    coachName: '',
    logoUrl: 'https://cdn.shopify.com/s/files/1/0609/6397/9463/files/Ice_Hockey_Coach_Scene_May_19_2025.png?v=1747651649',
    street: '',
    streetNumber: '',
    city: '',
    state: '',
    postalCode: '',
    country: '',
    languages: [] as string[],
    description: '',
    strengths: [] as string[],
    socialLinks: {
      website: '',
      instagram: '',
      facebook: '',
      twitter: '',
      linkedin: ''
    },
    services: [{ name: '', price: '' }],
    email: ''
  });

  useEffect(() => {
    const fetchProfile = async () => {
      if (!user) return;

      try {
        const q = query(
          collection(db, 'coach_profiles'),
          where('userId', '==', user.uid)
        );
        
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          const profileData = {
            id: querySnapshot.docs[0].id,
            ...querySnapshot.docs[0].data()
          } as CoachProfile;
          
          setProfile(profileData);
          setFormData({
            schoolName: profileData.schoolName,
            coachName: profileData.coachName,
            logoUrl: profileData.logoUrl || 'https://cdn.shopify.com/s/files/1/0609/6397/9463/files/Ice_Hockey_Coach_Scene_May_19_2025.png?v=1747651649',
            street: profileData.street,
            streetNumber: profileData.streetNumber,
            city: profileData.city,
            state: profileData.state,
            postalCode: profileData.postalCode,
            country: profileData.country,
            languages: profileData.languages,
            description: profileData.description,
            strengths: profileData.strengths,
            socialLinks: profileData.socialLinks,
            services: profileData.services,
            email: profileData.email
          });
        }
      } catch (err) {
        console.error('Error fetching profile:', err);
        setError(t('coachProfile.failedToLoadProfile'));
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [user]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!user) return;

    try {
      const profileData = {
        userId: user.uid,
        ...formData,
        updatedAt: new Date()
      };

      if (profile) {
        await updateDoc(doc(db, 'coach_profiles', profile.id), profileData);
        setProfile({ ...profile, ...profileData });
      } else {
        const docRef = await addDoc(collection(db, 'coach_profiles'), {
          ...profileData,
          createdAt: new Date()
        });
        setProfile({ id: docRef.id, ...profileData } as CoachProfile);
      }
      
      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000); // Hide success message after 3 seconds
    } catch (err) {
      console.error('Error saving coach profile:', err);
      setError(t('coachProfile.failedToSaveProfile'));
    }
  };

  const handleImageUpload = (url: string) => {
    setFormData(prev => ({ ...prev, logoUrl: url }));
  };

  const addService = () => {
    setFormData(prev => ({
      ...prev,
      services: [...prev.services, { name: '', price: '' }]
    }));
  };

  const removeService = (index: number) => {
    setFormData(prev => ({
      ...prev,
      services: prev.services.filter((_, i) => i !== index)
    }));
  };

  const updateService = (index: number, field: 'name' | 'price', value: string) => {
    setFormData(prev => ({
      ...prev,
      services: prev.services.map((service, i) => 
        i === index ? { ...service, [field]: value } : service
      )
    }));
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1b3968]"></div>
      </div>
    );
  }

  return (
    <div className='max-w-4xl mx-auto px-4 py-8'>
      <h1 className='text-2xl md:text-3xl font-bold text-primary-600 mb-8 italic'>
        {t('coachProfile.title')}
      </h1>

      {error && (
        <div className='bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-6'>
          {error}
        </div>
      )}

      {success && (
        <div className='bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-6 flex items-center gap-2'>
          <CheckCircle2 className='h-5 w-5' />
          {t('coachProfile.profileSavedSuccessfully')}
        </div>
      )}

      <form onSubmit={handleSubmit} className='space-y-6'>
        <div className='bg-white shadow rounded-lg p-6'>
          <h2 className='text-xl font-semibold mb-6'>{t('coachProfile.basicInformation')}</h2>

          <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                {t('coachProfile.schoolName')}
              </label>
              <input
                type='text'
                value={formData.schoolName}
                onChange={(e) =>
                  setFormData({ ...formData, schoolName: e.target.value })
                }
                className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                required
              />
            </div>

            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                {t('coachProfile.coachName')}
              </label>
              <input
                type='text'
                value={formData.coachName}
                onChange={(e) =>
                  setFormData({ ...formData, coachName: e.target.value })
                }
                className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                required
              />
            </div>

            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                {t('coachProfile.email')}
              </label>
              <input
                type='email'
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                required
              />
            </div>

            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                {t('coachProfile.languages')}
              </label>
              <input
                type='text'
                value={formData.languages.join(', ')}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    languages: e.target.value.split(',').map((s) => s.trim()),
                  })
                }
                className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                placeholder={t('coachProfile.languagesPlaceholder')}
                required
              />
            </div>
          </div>

          <div className='mt-6'>
            <label className='block text-sm font-medium text-gray-700 mb-1'>
              {t('coachProfile.description')}
            </label>
            <textarea
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
              className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
              rows={4}
              required
            />
          </div>

          <div className='mt-6'>
            <label className='block text-sm font-medium text-gray-700 mb-1'>
              {t('coachProfile.strengths')}
            </label>
            <input
              type='text'
              value={formData.strengths.join(', ')}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  strengths: e.target.value.split(',').map((s) => s.trim()),
                })
              }
              className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
              placeholder={t('coachProfile.strengthsPlaceholder')}
              required
            />
          </div>
        </div>

        <div className='bg-white shadow rounded-lg p-6'>
          <h2 className='text-xl font-semibold mb-6'>{t('coachProfile.address')}</h2>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
            <div className='md:col-span-2 grid grid-cols-2 gap-6'>
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  {t('coachProfile.street')}
                </label>
                <input
                  type='text'
                  value={formData.street}
                  onChange={(e) =>
                    setFormData({ ...formData, street: e.target.value })
                  }
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                  required
                />
              </div>
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  {t('coachProfile.streetNumber')}
                </label>
                <input
                  type='text'
                  value={formData.streetNumber}
                  onChange={(e) =>
                    setFormData({ ...formData, streetNumber: e.target.value })
                  }
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                  required
                />
              </div>
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                {t('coachProfile.city')}
              </label>
              <input
                type='text'
                value={formData.city}
                onChange={(e) =>
                  setFormData({ ...formData, city: e.target.value })
                }
                className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                required
              />
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                {t('coachProfile.stateProvince')}
              </label>
              <input
                type='text'
                value={formData.state}
                onChange={(e) =>
                  setFormData({ ...formData, state: e.target.value })
                }
                className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                required
              />
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                {t('coachProfile.postalCode')}
              </label>
              <input
                type='text'
                value={formData.postalCode}
                onChange={(e) =>
                  setFormData({ ...formData, postalCode: e.target.value })
                }
                className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                required
              />
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                {t('coachProfile.country')}
              </label>
              <Select
                value={countries.find(
                  (country) => country.value === formData.country
                )}
                onChange={(option) =>
                  setFormData({ ...formData, country: option?.value || '' })
                }
                options={countries}
                className='text-sm'
                classNamePrefix='react-select'
                placeholder={t('coachProfile.selectCountry')}
                isClearable={false}
                isSearchable={true}
                required
              />
            </div>
          </div>
        </div>

        <div className='bg-white shadow rounded-lg p-6'>
          <h2 className='text-xl font-semibold mb-6'>{t('coachProfile.logo')}</h2>
          <div className='flex items-start gap-6'>
            <div className='flex-shrink-0'>
              <img
                src={formData.logoUrl}
                alt={t('coachProfile.schoolLogo')}
                className='w-32 h-32 object-cover rounded-lg'
              />
            </div>
            <div className='flex-1'>
              <ImageUpload onUploadComplete={handleImageUpload} />
            </div>
          </div>
        </div>

        <div className='bg-white shadow rounded-lg p-6'>
          <h2 className='text-xl font-semibold mb-6'>{t('coachProfile.socialLinks')}</h2>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                {t('coachProfile.website')}
              </label>
              <div className='flex items-center'>
                <Globe className='h-5 w-5 text-gray-400 mr-2' />
                <input
                  type='url'
                  value={formData.socialLinks.website}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      socialLinks: {
                        ...formData.socialLinks,
                        website: e.target.value,
                      },
                    })
                  }
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                  placeholder='https://'
                />
              </div>
            </div>

            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                {t('coachProfile.instagram')}
              </label>
              <div className='flex items-center'>
                <Instagram className='h-5 w-5 text-gray-400 mr-2' />
                <input
                  type='url'
                  value={formData.socialLinks.instagram}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      socialLinks: {
                        ...formData.socialLinks,
                        instagram: e.target.value,
                      },
                    })
                  }
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                  placeholder='https://instagram.com/'
                />
              </div>
            </div>

            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                {t('coachProfile.facebook')}
              </label>
              <div className='flex items-center'>
                <Facebook className='h-5 w-5 text-gray-400 mr-2' />
                <input
                  type='url'
                  value={formData.socialLinks.facebook}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      socialLinks: {
                        ...formData.socialLinks,
                        facebook: e.target.value,
                      },
                    })
                  }
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                  placeholder='https://facebook.com/'
                />
              </div>
            </div>

            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                {t('coachProfile.twitter')}
              </label>
              <div className='flex items-center'>
                <Twitter className='h-5 w-5 text-gray-400 mr-2' />
                <input
                  type='url'
                  value={formData.socialLinks.twitter}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      socialLinks: {
                        ...formData.socialLinks,
                        twitter: e.target.value,
                      },
                    })
                  }
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                  placeholder='https://twitter.com/'
                />
              </div>
            </div>

            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                {t('coachProfile.linkedin')}
              </label>
              <div className='flex items-center'>
                <Linkedin className='h-5 w-5 text-gray-400 mr-2' />
                <input
                  type='url'
                  value={formData.socialLinks.linkedin}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      socialLinks: {
                        ...formData.socialLinks,
                        linkedin: e.target.value,
                      },
                    })
                  }
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                  placeholder='https://linkedin.com/in/'
                />
              </div>
            </div>
          </div>
        </div>

        <div className='bg-white shadow rounded-lg p-6'>
          <div className='flex justify-between items-center mb-6'>
            <h2 className='text-xl font-semibold'>{t('coachProfile.services')}</h2>
            <button
              type='button'
              onClick={addService}
              className='text-[#1b3968] hover:text-[#1b3968]/80 flex items-center gap-2'
            >
              <Plus className='h-5 w-5' />
              {t('coachProfile.addService')}
            </button>
          </div>

          <div className='space-y-4'>
            {formData.services.map((service, index) => (
              <div key={index} className='flex gap-4 items-start'>
                <div className='flex-1'>
                  <input
                    type='text'
                    value={service.name}
                    onChange={(e) =>
                      updateService(index, 'name', e.target.value)
                    }
                    placeholder={t('coachProfile.serviceName')}
                    className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                    required
                  />
                </div>
                <div className='w-32'>
                  <input
                    type='text'
                    value={service.price}
                    onChange={(e) =>
                      updateService(index, 'price', e.target.value)
                    }
                    placeholder={t('coachProfile.price')}
                    className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                  />
                </div>
                <button
                  type='button'
                  onClick={() => removeService(index)}
                  className='text-gray-400 hover:text-red-500 p-2'
                >
                  <Trash2 className='h-5 w-5' />
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className='flex justify-end'>
          <button
            type='submit'
            className='bg-[#1b3968] text-white px-6 py-2 rounded-md hover:bg-[#1b3968]/90 flex items-center gap-2'
          >
            <Save className='h-5 w-5' />
            {t('coachProfile.saveProfile')}
          </button>
        </div>
      </form>
    </div>
  );
}